import { render } from "./form-popup.vue?vue&type=template&id=21e3c780&scoped=true"
import script from "./form-popup.vue?vue&type=script&lang=js"
export * from "./form-popup.vue?vue&type=script&lang=js"

import "./form-popup.vue?vue&type=style&index=0&id=21e3c780&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e3c780"]])

export default __exports__